import React from 'react';
import Stack from '@mui/material/Stack';
import { SellerLegalInfo, SellerProfile } from '../Seller';
export const EshopDetail = ({ seller }) => {
    return (React.createElement(Stack, { spacing: 2 },
        !(seller === null || seller === void 0 ? void 0 : seller.isCrew) && React.createElement(SellerProfile, { seller: seller }),
        ((seller === null || seller === void 0 ? void 0 : seller.isPro) || (seller === null || seller === void 0 ? void 0 : seller.isCrew)) && React.createElement(SellerLegalInfo, { eshopLegalInfo: seller.legalNotice, isCrew: seller.isCrew })));
};
